import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [citation, setCitation] = useState("In a world filled with hate,\nwe must still dare to hope.");

  useEffect(() => {
    fetch('/api/citations').then(r => r.json()).then(data => {
      if (Array.isArray(data) && data.length > 0) {
        const rand = data[Math.floor(Math.random() * data.length)];
        setCitation(rand.text);
      }
    }).catch(() => {});
  }, []);

  return (
    <footer style={{ background: '#1a0808', borderTop: '2px solid #8b1a2a', fontFamily: 'Arial,sans-serif' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '48px 48px 32px' }}>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 40, marginBottom: 40 }}>

          {/* Colonne 1 — identité */}
          <div>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 20, color: '#fff', marginBottom: 10 }}>
              MJ — Vu par ceux qui l'ont aimé
            </div>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.8, marginBottom: 16 }}>
              Un site mémoriel créé par une fan, pour les fans. Ici, Michael Jackson est vu à travers les yeux de ceux qui l'ont aimé sincèrement.
            </p>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 13, color: '#e8a0a0', fontStyle: 'italic', lineHeight: 1.7 }}>
              "{citation}"
            </div>
          </div>

          {/* Colonne 2 — Pages */}
          <div>
            <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#e8a0a0', fontWeight: 700, marginBottom: 16 }}>PAGES</div>
            {[
              { to: '/', label: 'Accueil' },
              { to: '/scene', label: 'Sur scène' },
              { to: '/rencontres', label: 'Rencontres & hasards' },
              { to: '/etsi', label: 'Et si…' },
              { to: '/art', label: 'Art des fans' },
              { to: '/michael', label: 'Michael' },
              { to: '/documentaire', label: 'Documentaire' },
            ].map(l => (
              <Link key={l.to} to={l.to} style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.55)', textDecoration: 'none', marginBottom: 8, transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = '#e8a0a0'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >{l.label}</Link>
            ))}
          </div>

          {/* Colonne 3 — Communauté */}
          <div>
            <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#e8a0a0', fontWeight: 700, marginBottom: 16 }}>COMMUNAUTÉ</div>
            {[
              { to: '/temoigner', label: 'Témoigner' },
              { to: '/rencontres-fans', label: 'Rencontres fans' },
              { to: '/live', label: 'Live Cams' },
            ].map(l => (
              <Link key={l.to} to={l.to} style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.55)', textDecoration: 'none', marginBottom: 8 }}
                onMouseEnter={e => e.target.style.color = '#e8a0a0'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}
              >{l.label}</Link>
            ))}
          </div>

          {/* Colonne 4 — Contact */}
          <div>
            <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#e8a0a0', fontWeight: 700, marginBottom: 16 }}>CONTACT</div>
            <a href="mailto:contact@mjkop.com" style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.55)', textDecoration: 'none', marginBottom: 8 }}
              onMouseEnter={e => e.target.style.color = '#e8a0a0'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}
            >contact@mjkop.com</a>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', marginBottom: 8 }}>mjkop.com</div>
            <div style={{ marginTop: 16 }}>
              <Link to="/inscription" style={{ display: 'inline-block', padding: '8px 16px', borderRadius: 8, background: '#8b1a2a', color: '#fff', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}>
                Rejoindre la communauté
              </Link>
            </div>
          </div>
        </div>

        {/* Bas du footer */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)' }}>
            Chaque témoignage est <span style={{ color: '#e8a0a0' }}>relu avant publication</span>. Aucun message haineux accepté.
          </p>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)' }}>
            Site créé avec amour par une fan · 2026
          </p>
        </div>

        <div style={{ marginTop: 16, textAlign: 'center', display: 'flex', justifyContent: 'center', gap: 18, flexWrap: 'wrap' }}>
          <Link to="/mentions-legales" style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Mentions legales</Link>
          <Link to="/confidentialite" style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Politique de confidentialite</Link>
          <Link to="/cgu" style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Conditions d'utilisation</Link>
        </div>

      </div>
    </footer>
  );
}
